import {
    Box3,
    BoxGeometry,
    Group,
    Mesh,
    MeshBasicMaterial,
    Vector3,
} from 'three';
import {RoomPlannerProductWithTemplate} from 'components/customer/RoomPlanner/types';
import {TemplateVariable} from 'components/customer/Preview3D/usePreview3DData';
import {getCabinetBoundingBox} from 'components/customer/RoomPlanner/helpers/getCabinetBoundingBox';

export const generateCuboid = (product: RoomPlannerProductWithTemplate) => {
    const {height, width, depth, thickness} = getCabinetBoundingBox(product);

    const cabinetGroup = new Group();
    const geometry = new BoxGeometry(width, depth, height);
    const material = new MeshBasicMaterial({color: 0x808080});

    const cuboid = new Mesh(geometry, material);
    cuboid.position.x = width / 2;
    cabinetGroup.add(cuboid);

    const isRobeProduct = /Robe.*\.xml$/i.test(
        product.template_3d[0]?.attributes.template
    );
    const variables = JSON.parse(
        product.template_3d[0].attributes.variables
    ) as unknown as TemplateVariable;
    const noBottom =
        variables.noCornerBaseBottom ??
        Boolean(
            variables?.fields.find((field) => field.name === 'noBottom')
                ?.expression
        );

    cabinetGroup.userData.isRobeProduct = isRobeProduct;
    cabinetGroup.userData.noBottom = noBottom;
    cabinetGroup.userData.depth = depth * 0.2;

    const box = new Box3().setFromObject(cabinetGroup);
    const cabinetSize = box.getSize(new Vector3());

    box.min.set(0, thickness * -1, 1.9 * -1);
    box.max.set(width, depth - thickness, height);

    cabinetGroup.position.set(
        -box.min.x - cabinetSize.x / 2,
        -box.min.y - cabinetSize.y / 2,
        0
    );

    return cabinetGroup;
};
